import "./App.css";
import { useEffect,useRef } from "react";
import { useOktaAuth } from "@okta/okta-react";
import "bootstrap/dist/css/bootstrap.min.css";

export const AuthManager = () => {
  const { oktaAuth: oktaAuthInstance, authState } = useOktaAuth();
  const hasTriedRedirect = useRef(false);

  useEffect(() => {
    const login = async () => {
      // console.log("AuthManager: authState", authState);
      
      // Wait for authState to be available
      if (!authState) {
        // console.log("AuthManager: Waiting for authState...");
        return;
      }

      // console.log("AuthManager: isAuthenticated =", authState.isAuthenticated);
      // console.log("AuthManager: hasTriedRedirect =", hasTriedRedirect.current);

      // Only redirect if not authenticated and haven't tried redirecting yet
      if (!authState.isAuthenticated && !hasTriedRedirect.current) {
        hasTriedRedirect.current = true;
        try {
          // console.log("AuthManager: Initiating sign-in redirect...");
          await oktaAuthInstance.signInWithRedirect();
          // console.log("AuthManager: Sign-in redirect initiated successfully");
        } catch (error) {
          console.error("AuthManager: Error during sign-in redirect:", error);
          hasTriedRedirect.current = false; // Reset on error
        }
      } else if (!authState.isAuthenticated && hasTriedRedirect.current) {
        // console.log("AuthManager: Already tried redirect, waiting...");
      }
    };

    login();
  }, [authState, oktaAuthInstance]);
};
